import { render, staticRenderFns } from "./RegisterLayout.vue?vue&type=template&id=1dae7326&scoped=true"
import script from "./RegisterLayout.vue?vue&type=script&lang=js"
export * from "./RegisterLayout.vue?vue&type=script&lang=js"
import style0 from "./RegisterLayout.vue?vue&type=style&index=0&id=1dae7326&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dae7326",
  null
  
)

export default component.exports